import { faArrowLeft, faCapsules, faPills } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Row } from 'antd'
import React from 'react'
import { useDispatch } from 'react-redux'
import CoreEnums from '../../../../../core/utils/enums'
import coreReducer from '../../../../../core/utils/reducer'
import MobMedicalHistoryLoadingOverlay from '../../../Medical History/Mobile/components/LoadingOverlay'
import usePatChronicMeds from '../../hooks/usePatChronicMeds'
import '../Styling/MobileMedications.css'
import MobChronicMedicationsCarousel from './MobChronicMedicationsCarousel'
import MobGeneralMedicationsCarousel from './MobGeneralMedicationsCarousel'
import MobMedicationsHeader from './MobMedicationsHeader'
import MobMedicationsList from './MobMedicationsList'

const MobMedicationsWrapper = () => {
  const { loadingChronicMedications } = usePatChronicMeds()
  const dispatch = useDispatch()

  const closeTab = () => {
    dispatch(
      coreReducer.actions.closeTab({
        targetKey: CoreEnums.tabKeys.PAT_MEDICATIONS,
        removeBreadcrumb: true
      })
    )
  }

  return (
    <div className='mobile-medications' style={{ overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <Button
        onClick={closeTab}
        icon={<FontAwesomeIcon icon={faArrowLeft} size='lg' />}
        shape='circle'
        style={{
          position: 'absolute',
          top: '20px',
          left: '25px',
          zIndex: 10,
          backgroundColor: 'white',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      />
      {loadingChronicMedications ? (
        <MobMedicalHistoryLoadingOverlay loading={true} text={'Loading medications... '} />
      ) : (
        <>
          <MobMedicationsHeader />

          <Row>
            <Col span={24}>
              <div
                style={{ padding: '15px 20px 5px', fontSize: 16, display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <FontAwesomeIcon icon={faPills} style={{ color: '#00A6E3' }} />
                Chronic Medications
              </div>
            </Col>
          </Row>
          <MobChronicMedicationsCarousel />

          <Row>
            <Col span={24}>
              <div
                style={{ padding: '15px 20px 5px', fontSize: 16, display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <FontAwesomeIcon icon={faCapsules} style={{ color: '#FF8A66' }} />
                General Medications
              </div>
            </Col>
          </Row>
          <MobGeneralMedicationsCarousel />

          <MobMedicationsList />
        </>
      )}
    </div>
  )
}

export default MobMedicationsWrapper
